import { Col } from 'antd'
import React, { ReactElement, useState } from 'react'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { MembersManagementPage } from './membersManagementPage'
import { MemberBenefits } from './MemberBenefits'
import { MembersCardManagementPage } from './detail/membersCardManagement'
import { MemberPoints } from './MemberPoints'
import { ExchangeRecordPage } from './ExchangeRecordPage'

export const MembersManagementTabs = (): ReactElement => {
  const [activeTab, setActiveTab] = useState('0')

  return (
    <Col
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'hidden',
      }}
    >
      <TabBar
        style={{ margin: '10px 20px' }}
        activeKey={activeTab}
        destroyInactiveTabPane
        onChange={(key) => setActiveTab(key)}
      >
        <TabPane key="0" tab="会员管理">
          <MembersManagementPage isMenu={true} inTab />
        </TabPane>
        <TabPane key="1" tab="会员权益">
          <MemberBenefits inTab />
        </TabPane>
        <TabPane key="2" tab="会员卡管理">
          <MembersCardManagementPage inTab />
        </TabPane>
        <TabPane key="3" tab="会员积分">
          <MemberPoints inTab />
        </TabPane>
        <TabPane key="4" tab="会员使用记录">
          <ExchangeRecordPage />
        </TabPane>
      </TabBar>
    </Col>
  )
}
